import React, { Suspense, Fragment } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { createMuiTheme } from "./theme";
import { AuthProvider } from "./context/Auth"; // Use AuthProvider
import PageLoading from "./components/PageLoading";
import AuthGuard from "./config/AuthGuard";
import { ThemeProvider } from "@mui/material/styles";
import { Toaster } from "react-hot-toast";
import Unauthorized from "./components/Unauthorized";
import { routes } from "./routes";
import "./scss/main.css";

function App() {
  const theme = createMuiTheme({ theme: "light", direction: "ltr" });

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <AuthProvider>
            <Router>
              <Toaster position="top-right" />
              <RenderRoutes data={routes} />
            </Router>
          </AuthProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </div>
  );
}

function RenderRoutes({ data }) {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        {data.map((route, index) => {
          const Component = route.component;
          const Layout = route.layout || Fragment;

          // Wrap protected routes with AuthGuard
          const RouteElement = route.auth ? (
            <AuthGuard>
              <Layout>
                <Component />
              </Layout>
            </AuthGuard>
          ) : (
            <Layout>
              <Component />
            </Layout>
          );

          return <Route key={index} path={route.path} element={RouteElement} />;
        })}
        {/* Unauthorized Route */}
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </Suspense>
  );
}

export default App;
